<template>
  <svg
    width="14"
    height="12"
    viewBox="0 0 14 12"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
  >
    <path
      d="M1.5 0.75C1.07812 0.75 0.75 1.07812 0.75 1.5V8.25C0.75 8.67188 1.07812 9 1.5 9C1.59375 7.94531 2.48438 7.125 3.5625 7.125C4.64062 7.125 5.53125 7.94531 5.625 9H7.875C7.94531 8.27344 8.39062 7.66406 9 7.35938V1.5C9 1.07812 8.67188 0.75 8.25 0.75H1.5ZM9.75 6V7.125C9.82031 7.125 9.86719 7.125 9.9375 7.125C11.0156 7.125 11.9062 7.94531 12 9C12.4219 9 12.75 8.67188 12.75 8.25V6H9.75ZM12.75 5.25V4.59375C12.75 4.38281 12.6797 4.19531 12.5391 4.05469L11.6953 3.21094C11.5547 3.07031 11.3672 3 11.1562 3H9.75V5.25H12.75ZM1.57031 9.75H1.5C0.679688 9.75 0 9.07031 0 8.25V1.5C0 0.679688 0.679688 0 1.5 0H8.25C9.07031 0 9.75 0.679688 9.75 1.5V2.25H11.1562C11.5547 2.25 11.9297 2.41406 12.2109 2.69531L13.0547 3.53906C13.3359 3.82031 13.5 4.19531 13.5 4.59375V8.25C13.5 9.07031 12.8203 9.75 12 9.75H11.9297C11.6719 10.6172 10.875 11.25 9.9375 11.25C9 11.25 8.20312 10.6172 7.94531 9.75H5.55469C5.29688 10.6172 4.5 11.25 3.5625 11.25C2.625 11.25 1.82812 10.6172 1.57031 9.75ZM3.5625 10.5C4.28906 10.5 4.875 9.91406 4.875 9.1875C4.875 8.46094 4.28906 7.875 3.5625 7.875C2.83594 7.875 2.25 8.46094 2.25 9.1875C2.25 9.91406 2.83594 10.5 3.5625 10.5ZM9.9375 10.5C10.6641 10.5 11.25 9.91406 11.25 9.1875C11.25 8.46094 10.6641 7.875 9.9375 7.875C9.21094 7.875 8.625 8.46094 8.625 9.1875C8.625 9.91406 9.21094 10.5 9.9375 10.5Z"
      fill="currentColor"
    />
  </svg>
</template>

<script>
// currentColor em vez do #234e79 do arquivo original: e o mesmo valor de @color-primary, e
// assim o icone continua obedecendo a cor de quem o usa.
export default {
  name: "FreightTableTruckIcon",
};
</script>
